import { render, staticRenderFns } from "./AxArtboardUploadsProgress.vue?vue&type=template&id=e462bba2&scoped=true&"
import script from "./AxArtboardUploadsProgress.vue?vue&type=script&lang=ts&"
export * from "./AxArtboardUploadsProgress.vue?vue&type=script&lang=ts&"
import style0 from "./AxArtboardUploadsProgress.vue?vue&type=style&index=0&id=e462bba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e462bba2",
  null
  
)

export default component.exports